import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  sliderItem: {
    display: "flex !important",
  },
  sliderImage: {
    display: "flex",
    width: "100%",
    height: 647,
    [theme.breakpoints.down("md")]: {
      height: 330,
    },
  },
}));

export default useStyles;
